//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useEffect,
  useContext,
  Fragment,
  useCallback,
} from "react";
import * as moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { toastCss } from "assets/styleJS/global";
import { parseISO } from "date-fns";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";


// custom pages
import Table from "components/Table/Table";
import thriveBackDateAPI from "apis/thriveBackDate/thriveBackDate";
import AuditAPI from "apis/audit/audit";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import useDebounce from "helpers/useDebounce";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";
import { ImportDataHeader } from "./Headers/headers";
import { exporDatatHeaders } from "./Headers/headers";

import { CSVLink } from 'react-csv';

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
// import Grid from "@material-ui/core/Grid";
import { Grid, MenuItem } from '@material-ui/core';

import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import HistoryIcon from "@material-ui/icons/History";
import { pointsFormat } from "helpers/dataFormat";
const Papa = require("papaparse/papaparse.min.js");

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "&.MuiFormControl-fullWidth": {
        width:"40%"
      },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      }
      
    },
  },
})(TextField);


const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#2F7CBD",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#2F7CBD",
      border: "6px solid #2F7CBD",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid gray`,
    backgroundColor: "gray",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function ShiptoDetails() {
  const { getAPI, searchAPI, updateAPI, courtesyPointsCalculation, exportAPI } = thriveBackDateAPI();
  const { getAudit } = AuditAPI();
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(Context);
  const classes = Styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const [minimalDate, setMinimalDate] = useState(180);
  const [tier, setTier] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [pointsUpdateObj, setPointsUpdateObj] = useState({
    open: false,
    amount: 0,
    count: 0,
    courtesyPoints: 0,
    points: 0,
    isConfirm: false
  });
  const [updateObj, setUpdateObj] = useState({
    index: 0,
    obj: {},
    modal: false,
    thriveStartDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
    thriveEndDate: moment(new Date()).format('YYYY-MM-DD'),
    type: "",
    tier:'',
    tierRatio:''
  });
  const [updateLoading, setUpdateLoading] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [exportFileName, setExportFileName] = useState("");


  const [fileName, setFileName] = useState("");

  // Common State Object
  const [states, setstates] = useState({
    clearSearch: false,
    historyDialog: false,
    historyLoader: false,
    data: []
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
});
const { clearSearch } = states;

  const { t, i18n } = useTranslation();
  let selectedColumns = ImportDataHeader.map((header) => header.label);

  let tableHeading = [
    "Member ID",
    "Billto",
    "Shipto",
    "Shipto Name",
    "Status",
    // "Start Date",
    // "End Date",
    "Dormant Status",
    "Thrive Rewards Backdate",
    "History",
  ];

  const handlePagination = (value) => {
    setOffset(value);
  };
 

  // handling search api


 // Handling Get and Search API
 useEffect(() => {
  if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
          handleSearch();
      }
      else {
          handleGet();
      }
  }
  else {
      setStates({ clearSearch: false });
  }
}, [searchBounceValues, offset]);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Thrive Rewards Backdate"],
    });
  }, []);

  // Get data API
  async function handleGet() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setTier(res?.tierRatio)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Search data API
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setTier(res?.tierRatio)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Update thrive API
  const handleUpdateThrive = async () => {
    toast.dismiss();
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        id: updateObj?.obj?._id,
        customer_account_number: updateObj?.obj?.customer_account_number,
        loyalty_id:updateObj?.obj?.loyalty_id,
        customer_billto_account_number:updateObj?.obj?.customer_billto_account_number,
        points:pointsUpdateObj?.points

      };

      if(updateObj?.type =="CurrentTier"){
          values = { ...values, date: updateObj?.thriveStartDate,tier:updateObj?.obj.current_tier,tier_ratio:updateObj?.tierRatio,type:updateObj?.type,endDate:updateObj?.thriveEndDate};

         }
         else if(updateObj?.type =="InitialTier"){
          values = { ...values, date: updateObj?.thriveStartDate,tier:updateObj?.obj?.initial_tier,tier_ratio:updateObj?.tierRatio,type:updateObj?.type,endDate:updateObj?.thriveEndDate};

         }else {
        values = { ...values, date: updateObj?.thriveStartDate,tier:updateObj?.tier,tier_ratio:updateObj?.tierRatio,type:updateObj?.type,endDate:updateObj?.thriveEndDate};
        }        

      let res = await updateAPI(values);
      if (res && res?.type === "SUCCESS") {
        

         let msg = "Account has been backdated successfully";
        
        toast.success(msg, { tostId: "thrive-update-success" });
        setUpdateObj({
          index: 0,
          obj: {},
          modal: false,
          thriveStartDate: moment().subtract(1, 'days').format('YYYY-MM-DD'), 
          thriveEndDate: moment().format('YYYY-MM-DD'), 
          type: "",
        });
        if (offset === 1) {
          handleGet();
        } else {
          setOffset(1);
        }
      }
      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  // Get thrive history
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "thriveaudit",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleGetCalculatedCourtesyPoints = async () => {
    try {
      setUpdateLoading(true);
      let values;
      if(updateObj?.type =="CurrentTier"){
          values = {
              startDate: updateObj?.thriveStartDate,
              endDate: updateObj?.thriveEndDate,
              customerAccount: updateObj?.obj?.customer_account_number,
              tier:updateObj?.obj.current_tier,
              tier_ratio:updateObj?.tierRatio,
              type:updateObj?.type
            };
         
         }
         else if(updateObj?.type =="InitialTier"){
          values = {
              startDate: updateObj?.thriveStartDate,
              endDate: updateObj?.thriveEndDate,
              customerAccount: updateObj?.obj?.customer_account_number,
              tier:updateObj?.obj?.initial_tier,
              tier_ratio:updateObj?.tierRatio,
              type:updateObj?.type
            };
         
         }else {
          values = {
              startDate: updateObj?.thriveStartDate,
              endDate: updateObj?.thriveEndDate,
              customerAccount: updateObj?.obj?.customer_account_number,
              tier:updateObj?.tier,
              tier_ratio:updateObj?.tierRatio,
              type:updateObj?.type
            };      
         }
  

      let res = await courtesyPointsCalculation(values);
      setUpdateLoading(false);
      if (res) {
        setPointsUpdateObj({
          ...pointsUpdateObj,
          open: true,
          isConfirm: false,
          amount: pointsFormat(res.amount || 0, 'en'),
          count: pointsFormat(res.count || 0, 'en'),
          points: pointsFormat(res.points || 0, 'en'),
          courtesyPoints: pointsFormat(res.courtesyPoints || 0, 'en'),
          totalPoints: pointsFormat(res.courtesyPoints + res.points || 0, 'en')
        })
      } else {
        handleUpdateThrive();
      }
    } catch (e) {
      console.log({ e });
    }
  }
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }

    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);

    let res = await exportAPI(values);
    if (res && res?.type === "ERROR") {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      setStates({
        pLoading: false,
        eLoading: false,
        errorDialog: true,
        errorCount: res?.count,
      });
    }
    if (res && res.data) {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      setExportData(res.data.map(obj => {
        return {
          ...obj,
          
        }
      }));
      setExportFileName('Thrive_ACCOUNTS')
      setExportHeaders(exporDatatHeaders)
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      setStates({
        response: true,
        pLoading: false,
        eLoading: false,
      });
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };


  function selectedColumnFun() {
    {
      setStates({ data: [] });
      let data = [];
      ImportDataHeader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });
      setStates({ selectedFields: data });
    }
  }

  // Function to get the larger date
  const getLargerDate = (date1, date2) => {
    // Parse the dates using moment
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);

    // Compare the dates and return the larger date
    return momentDate1.isAfter(momentDate2) ? momentDate1 : momentDate2;
  };

  return (
    <Fragment>
      <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
        <CssTextField
          id="enterPassword"
          placeholder={t("Search for Billto or Shipto")}
          onKeyDown={blockInvalidChar}
          type={"number"}
              onWheel={(e) => e.target.blur()}
          variant="outlined"
          autoComplete="off"
          className={classes.searchInput}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 ? (
                  <CloseOutlinedIcon
                    className={classes.searchInputIcon}
                    onClick={() => {
                      setStates({ clearSearch: true });
                                                setSearchValue("");
                                                if (offset === 1) {
                                                    handleGet();
                                                }
                                                else {
                                                    setOffset(1);
                                                }
                    }}
                  />
                ) : (
                  <img
                    src={searchIcon}
                    alt=""
                    width="20px"
                    className={classes.searchInputIcon}
                  />
                )}
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => {
            e.target.value.replace(/\s+/g, "").length == 0
              ? setSearchValue("")
              : setSearchValue(e.target.value);
            if (e.target.value.length == 0) {
              handleGet();
            }
          }}
          onClick={() => {
            setOffset(1);
          }}
        />
  
      </Grid>
      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div key={t(i)}>{t(i)}</div>;
            })}
            data={
              data &&
              data.length > 0 &&
              data.map((d, i) => [
                d?.loyalty_id,
                d?.customer_billto_account_number,
                d?.customer_account_number,
                d?.["customer_name"],
                d?.checked ?
                 
                    <span className={classes.redBtn}>{"YES"}</span>
                   :
                    
                      <span className={classes.greenBtn}>{"NO "}</span>
                    ,
                    d?.dormant_account_flag ?
                    <span>Active</span>:
                    <span>-</span>,
               
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={d?.checked}
                       disabled={d?.checked}
                      onChange={() => {
                        // if(access['editAccess'][state.userInfo?.role]['member-details'] ){
                          const dormantFlag = d?.dormant_account_flag === true 
                          const dormantProcessed = d?.dormant_processed === true
                          if(dormantFlag === true && dormantProcessed === true){
                            return toast.error("Backdating Restricted! Since this account is currently in Dormant status. Reactivate their account in the 'Manage My Account' screen to proceed further.", {
                              toastId: "invalid-thrive-startdate-error",
                            });

                          }
                          if (dormantFlag === true && dormantProcessed === false ) {
                          toast.error("Backdating Restricted! Since this account is currently in Dormant status.");
                          return;
                          }
                    
                          setUpdateObj({
                            ...updateObj,
                            index: i,
                            obj: d,
                            modal: true,
                          
                          });
                       
                        setData([
                          ...data.slice(0, i),
                          { ...data[i], checked: !d?.checked },
                          ...data.slice(i + 1),
                        ]);
                        return;
                       
                      }}
                      name=""
                    />
                  }
                />,
                state?.userInfo?.auditAccess && (
                  <HistoryIcon
                    style={{ cursor: "pointer", verticalAlign: "middle" }}
                    onClick={() => {
                      setStates({
                        historyDialog: true,
                        historyLoader: true,
                      });
                      handleGetHistoryData(d?._id);
                    }}
                  />
                ),
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{t("Loading...")}</h2>
          </div>
        )}
      </div>
      {/* Signature handling dialog */}
      <Dialog
        maxWidth={"md"}
        aria-labelledby="simple-dialog-title"
        open={updateObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
         {/* <div className={classes.parentText}>{t("Thrive Backdate")}</div> */}
          
          <div className={classes.parentText2}>
            {/* &nbsp;&nbsp;&nbsp; */}

            <Fragment>
                <span>
                  {t(
                    `Member ID : ${updateObj.obj?.loyalty_id}` 
                  )}
                </span>
                <br />

              </Fragment>

            <Fragment>
                <span>
                  {t(
                    `Initial Tier : ${updateObj.obj?.initial_tier}` 
                  )}
                </span>
                <br />

              </Fragment>

            
              <Fragment>
                <span>
                  {t(
                    `Current Tier : ${updateObj.obj?.current_tier}` 
                  )}
                </span>
                <br />

              </Fragment>
         
        
          </div>
          <br />
          <Fragment>
          <Fragment>
                <span>
                  {t(
                    `Select the Member’s Start Date`
                  )}
                </span>
                <br />

              </Fragment>
          
              <Fragment>
             
                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      required
                      className={classes.dateInput}
                      maxDate={moment().subtract(1, 'days').format('YYYY-MM-DD')}
                      minDate={moment().subtract(minimalDate, 'days') }
                      value={parseISO(updateObj?.thriveStartDate)}
                      onChange={(date) => {
                        let d = moment(date).format("YYYY-MM-DD");
                        setUpdateObj({
                          ...updateObj,
                          thriveStartDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>

                </div>
                <br/>
                <span>
                  {t(
                    `Select the Member’s End Date`
                  )}
                </span>
                <br />
                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      required
                      className={classes.dateInput}
                      maxDate={moment().format('YYYY-MM-DD')}
                      minDate={updateObj?.thriveStartDate?moment(updateObj?.thriveStartDate).format('YYYY-MM-DD'):moment().subtract(minimalDate, 'days') }
                      value={parseISO(updateObj?.thriveEndDate)}
                      onChange={(date) => {
                        let d = moment(date).format("YYYY-MM-DD");
                        setUpdateObj({
                          ...updateObj,
                          thriveEndDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>

                </div>
                <br/>
              
                <div className={classes.subParentBody}>

                  <CssTextField
                  className={classes.tierbody}
                  id='tier'
                  label={t('Tier')}
                  select
                  // required
                //  fullWidth
                 onfocus="this.removeAttribute('readonly')"
                 value={updateObj?.tier}
                  onChange={(e) => { 
                    let tierRatio
                   if( e.target.value==="CurrentTier"){
                    setUpdateObj({
                      ...updateObj,
                      tier: e.target.value,
                     
                      tierRatio:tier?.find(element => element?.tier == updateObj?.obj.current_tier).tier_ratio,
                      type:e.target.value
                     
                      
                    });


                   }
                   else if(e.target.value==="InitialTier"){

                    setUpdateObj({
                      ...updateObj,
                      tier: e.target.value,
                     
                      tierRatio:tier?.find(element => element?.tier == updateObj?.obj.initial_tier).tier_ratio,
                      type:e.target.value
                     
                      
                    });
                   }
                   else{
                  
                    setUpdateObj({
                    ...updateObj,
                    tier: e.target.value,
                   
                    tierRatio:tier?.find(element => element?.tier == e.target.value).tier_ratio,
                    type:'admin choose'
                   
                    
                  });
                }
               
                   
                  }}
                >
                  {[
                    <MenuItem key="CurrentTier" value="CurrentTier">
                      Current Tier
                    </MenuItem>,
                    <MenuItem key="InitialTier" value="InitialTier">
                      Initial Tier
                    </MenuItem>,
                    ...tier?.map((item) => (
                      <MenuItem key={item?.tier} value={item?.tier}>
                        {item?.tier}
                      </MenuItem>
                    )),
                  ]}
                </CssTextField>
                </div>

                <div></div>
               
              </Fragment>
          
          </Fragment>
          
         
          <br />
        
            {/* <span className={classes.parentText2Note}>
              {t(
                "Note: Thrive benefits will be awarded according to the start date that is selected."
              )}
            </span> */}
          
          <br />
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(0, updateObj?.index),
                        {
                          ...data[updateObj?.index],
                          checked: !data[updateObj?.index]?.checked,
                        },
                        ...data.slice(updateObj?.index + 1),
                      ]);
                      setUpdateObj({
                        index: 0,
                        obj: {},
                        modal: false,
                        thriveStartDate: moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD'),
                        thriveEndDate: moment(new Date()).format('YYYY-MM-DD'),
                        
                        type: "",
                      });
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                   

                        if (moment(updateObj?.thriveStartDate).isBefore(moment().subtract(minimalDate, 'days').format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Date should not be before minimal date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                        if (moment(updateObj?.thriveEndDate).isBefore(moment(updateObj?.thriveStartDate).format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Date should not be before Start date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                        if (!updateObj?.tierRatio) {
                          toast.dismiss();
                          return toast.error("Please select Tier.", {
                            toastId: "tier-empty",
                          });
                        }
                        if (moment(updateObj?.thriveStartDate).isAfter(moment().format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Invalid Start Date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                        if (moment(updateObj?.thriveEndDate).isAfter(moment().format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Invalid End Date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                    
                       
                        if (updateObj?.thriveStartDate === "Invalid date") {
                          toast.dismiss();
                          return toast.error("Invalid Start Date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                        if (updateObj?.thriveEndDate === "Invalid date") {
                          toast.dismiss();
                          return toast.error("Invalid Start Date", {
                            toastId: "invalid-thrive-startdate-error",
                          });
                        }
                        if (moment(updateObj.thriveStartDate).isBefore(moment().format('YYYY-MM-DD'))) {
                          return handleGetCalculatedCourtesyPoints()
                        }
                      
                      
                      handleUpdateThrive();
                    }}
                  >
                    {t("Update")}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={pointsUpdateObj?.open}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        <div className={classes.dialogParentDiv} style={{ margin: 20, background: "#ddd" }}>
          <div className={classes.parentText} style={{ textAlign: 'center' }}>{`${t("Confirm")} Additional Thrive Points`}</div>

          <div className={classes.tdiv}>
            <div className={classes.parentText3}>
              {`Shipto ID : ${updateObj?.obj?.customer_account_number}`}
            </div>
            <table style={{ margin: 20 }}>
              <tr>
                <td className={classes.td}>Total Transaction Count</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.count}</strong></td>
              </tr>
              <tr>
                <td className={classes.td}>Total Eligible Purchase Amount</td>
                <td className={classes.td}><strong>${pointsUpdateObj?.amount}</strong></td>
              </tr>
              <tr>
                <td className={classes.td}>Total Additional Points</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.points}</strong></td>
              </tr>
              {/* <tr>
              <td className={classes.td}>The actual total points must be given</td>
              <td className={classes.td}><strong>{pointsUpdateObj?.totalPoints}</strong></td>
            </tr> */}
              {/* <tr>
                <td className={classes.td}>Total Additional Points</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.courtesyPoints}</strong></td>
              </tr> */}
            </table>

          </div>

 
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: "20px 20px 0px 20px" }}>
            {!updateLoading ? (
              <>
                <Button className={classes.cancelBtn} style={{ fontSize: 12, borderWidth: 1, borderRadius: 5 }} onClick={() => setPointsUpdateObj({ ...pointsUpdateObj, open: false, isConfirm: false })}>Cancel</Button>
                <Button className={classes.proceedBtn} style={{ fontSize: 12, borderRadius: 5 }} onClick={async () => {
                  // if (!pointsUpdateObj?.isConfirm) return document.getElementById('confirmMsg').style.color = 'red';
                  await handleUpdateThrive()
                  setPointsUpdateObj({ ...pointsUpdateObj, open: false })
                }}>Proceed</Button>
              </>
            ) :
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>}
          </div>
        </div>
      </Dialog>
      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            History{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
         
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                
                  `points given from ${moment(d?.new_value).format("YYYY-MM-DD")} to ${moment(d?.old_value).format("YYYY-MM-DD")} `,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={bulkUploadOpen}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        
      </Dialog>
      <CSVLink
        id='csv'
        data={exportData}
        headers={exportHeaders}
        filename={exportFileName +
          ' ' +
          moment(new Date()).format('MM-DD-YYYY,h:mm A') +
          '.csv'
        }
        className={classes.CSVlink}
      />
    </Fragment >
  );
}
